import { FC, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'

import { LiveError, LivePreview, LiveProvider } from 'react-live'
import { NavLink, useLocation } from 'react-router-dom'
import { MainContainer } from '../../containers'
import { useFetch, usePreviewMode, useRenderPath } from '../../hooks'
import { cx, templatesApiUrl } from '../../utils'
//@ts-ignore
import Icon from '@gjirafatech/gjirafa-icons/Icon'
import { SectionLoader } from '../../components/account'
import { toast } from 'react-toastify'

interface NewsletterResponse {
  success: boolean
  jobId?: string | null
  message?: string
  errorMessage?: string | null
}

export const Newsletter: FC = () => {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const { isPreviewMode } = usePreviewMode()
  const { renderPath } = useRenderPath(isPreviewMode)

  const alias = pathname.replace('/', '')
  const {
    apiCall: getNewsletterTemplate,
    response: newsletterTemplate,
    loading: newsletterTemplateLoading
  } = useFetch('get')

  const { apiCall: changeNewsletterSubscription, loading: newsletterLoading } =
    useFetch('post')

  const { apiCall: getNewsletterStatus, response, loading } = useFetch('get')

  useEffect(() => {
    getNewsletterStatus(`ManageApi/KlaviyoSubscriptionStatus`)
    getNewsletterTemplate(templatesApiUrl(alias, isPreviewMode))
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleNewsletterToggle = () => {
    const isSubscribed = response?.isSubscribed

    const url = isSubscribed
      ? 'ManageApi/KlaviyoUnsubscribeUser'
      : 'ManageApi/KlaviyoSubscribeUser'

    const messages = {
      success: isSubscribed
        ? t('newsletter.unsubscribedSuccessfully')
        : t('newsletter.subscribedSuccessfully'),
      error: isSubscribed
        ? t('newsletter.failedToUnsubscribe')
        : t('newsletter.failedToSubscribe')
    }

    changeNewsletterSubscription(
      url,
      undefined, // no data
      (res: NewsletterResponse) => {
        if (res?.success) {
          toast.success(messages.success)
          getNewsletterStatus(`ManageApi/KlaviyoSubscriptionStatus`)
        } else {
          toast.error(res?.errorMessage || messages.error)
        }
      },
      error => {
        const errMsg = error?.response?.data?.message || messages.error
        toast.error(t(errMsg))
      }
    )
  }
  const isSubscribed = response?.isSubscribed
  const requestAlreadySent = response?.requestAlreadySent

  const scope = {
    NavLink,
    t,
    cx,
    isSubscribed,
    requestAlreadySent,
    loading,
    Icon,
    SectionLoader,
    renderPath,
    handleNewsletterToggle,
    newsletterLoading
  }

  return (
    <>
      <Helmet>
        <title className="text-primary">
          {t<string>('homePage.myAccount')}
        </title>
        <style>{newsletterTemplate?.css}</style>
      </Helmet>
      <MainContainer>
        {!newsletterTemplateLoading && (
          <LiveProvider
            code={newsletterTemplate?.html || '<></>'}
            scope={scope}
          >
            <LivePreview />
            <LiveError />
          </LiveProvider>
        )}
      </MainContainer>
    </>
  )
}
